import React, { memo } from 'react'
import { Button, Icon, Modal } from 'antd'
import { COLORS, releaseModalFocus } from './utils'

const ImageBox = ({ label, src, active }) => (
  <div style={{ textAlign: 'center' }}>
    <div
      style={{
        fontSize: 12,
        color: active ? COLORS.primary : COLORS.textMuted,
        marginBottom: 8,
        fontWeight: 500
      }}
    >
      {label}
    </div>
    <div
      style={{
        width: 150,
        height: 150,
        borderRadius: 8,
        overflow: 'hidden',
        border: active
          ? `2px solid ${COLORS.primary}`
          : `1px solid ${COLORS.border}`,
        background: COLORS.background
      }}
    >
      {src ? (
        <img
          src={src}
          alt={label}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: COLORS.textMuted,
            fontSize: 12
          }}
        >
          No image
        </div>
      )}
    </div>
  </div>
)

const ConfirmSaveModal = memo(
  ({ visible, currentImage, selectedImage, onCancel, onConfirm }) => (
    <Modal
      maskClosable={false}
      title="Confirm Image Replacement"
      visible={visible}
      onCancel={() => releaseModalFocus(onCancel)}
      afterClose={releaseModalFocus}
      centered
      width={500}
      footer={[
        <Button key="cancel" onClick={() => releaseModalFocus(onCancel)}>
          Cancel
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={() => releaseModalFocus(onConfirm)}
          style={{ background: COLORS.primary, borderColor: COLORS.primary }}
        >
          Confirm & Save
        </Button>
      ]}
    >
      <div style={{ textAlign: 'center' }}>
        <p
          style={{
            fontSize: 14,
            color: COLORS.textSecondary,
            marginBottom: 20
          }}
        >
          This will replace the current shot image with your selected image.
        </p>
        <div
          style={{
            display: 'flex',
            gap: 18,
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ImageBox label="Current Image" src={currentImage} />
          <Icon type="arrow-right" style={{ fontSize: 22, color: COLORS.textMuted }} />
          <ImageBox label="New Image" src={selectedImage} active />
        </div>
      </div>
    </Modal>
  )
)

export default ConfirmSaveModal
